/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type VisitorConsentSource = (typeof VisitorConsentSource)[keyof typeof VisitorConsentSource];

export const VisitorConsentSource = {
  Banner: "Banner",
  Override: "Override",
  Gpc: "Gpc",
  Import: "Import",
  PolicyDefault: "PolicyDefault",
} as const;
